/** Último ingreso (Eduardo 2026-10-03).
 *
 * Renovar la sesión ya no cuenta como «entrar»: una pestaña olvidada se
 * renueva sola y el admin parecía activo hasta 30 días. En su lugar la app
 * avisa al servidor (POST /auth/visit) cuando la persona la usa de verdad: con
 * el primer clic o tecla, y luego a lo más cada 15 min por pestaña. Abrir la
 * app sola no cuenta: tras cada publicación las pestañas abiertas se recargan
 * solas y una pantalla olvidada a la vista parecería «entrar» cada día. Sin
 * temporizadores: solo reacciona a lo que hace la persona. El servidor escribe
 * a lo más una vez por hora, así que la hora mostrada se atrasa ~1 h 15 min
 * como mucho.
 */

import type { RoleCode } from "./api";

/** Menor que la hora del servidor a propósito: si la pestaña esperara la hora
 * completa desde un aviso que el servidor no escribió (otra pestaña ya lo había
 * hecho), la hora mostrada podía atrasarse casi 2 h. */
export const VISIT_PING_MS = 15 * 60 * 1000;

/** Solo se rastrea el uso del staff (lo que el superadmin revisa en
 * Administradores). De jugadores y familias, no: lo que el organizador ve de
 * ellos sigue siendo su último inicio de sesión. */
const TRACKED_ROLES: readonly RoleCode[] = ["admin", "superadmin", "club"];

export function tracksVisits(roles: readonly RoleCode[] | undefined): boolean {
  return Boolean(roles?.some((role) => TRACKED_ROLES.includes(role)));
}

/** Último aviso de esta pestaña: de qué cuenta y cuándo (ms). */
export interface VisitMark {
  sub: string;
  at: number;
}

/** ¿Toca avisar? Nunca avisado (o era otra cuenta): sí; luego, cada 15 min.
 * Un reloj que se atrasó tampoco deja la marca congelada. */
export function shouldPingVisit(last: VisitMark | null, sub: string, nowMs: number): boolean {
  if (!last || last.sub !== sub) return true;
  const elapsed = nowMs - last.at;
  return elapsed >= VISIT_PING_MS || elapsed < 0;
}
